import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { GreenroomState as GS } from '../../stores/types/types';
import { ROOM_STATES } from "../../stores/reducers/settings";
import Icon, { COLORS, ICONS } from "../general-components/icon";

interface SipCallOptionsProps {
	className?: string;
    sipStreamId: string;
	isHovering: boolean;
	videoRef?: HTMLElement | null;
	isForShotEditorModal: boolean;
    expanded: boolean | undefined;
    toggleExpandedCallback: (sipStreamId: string) => void;
}

export default function SipCallHoverOptions(props: SipCallOptionsProps) {
	const {
		className,
        sipStreamId,
		isHovering,
		videoRef,
		isForShotEditorModal,
        expanded,
        toggleExpandedCallback,
	} = props;

	const roomState = useSelector((state: GS) => state.MeetingReducer.roomState);

	const timmy = useRef<NodeJS.Timer | null>(null);
    
	const [locationData, setLocationData] = useState<DOMRect | undefined>(videoRef?.getBoundingClientRect
		? videoRef?.getBoundingClientRect()
		: undefined);

    useEffect(() => {
        if (timmy.current) {
            clearInterval(timmy.current);
            timmy.current = null;
        }
        if (!timmy.current) {
            timmy.current = setInterval(() => {
                setLocationData(videoRef?.getBoundingClientRect
                    ? videoRef?.getBoundingClientRect()
                    : undefined);
            }, 100);
        }
        return () => {
            if (timmy.current) {
                clearInterval(timmy.current);
                timmy.current = null;
            }
        };
    }, [videoRef]);

	if (!sipStreamId || !locationData) {
		return (<></>);
	}

	return (
		<div
			className={classNames('video-hover-options', className)}
			style={{
				position: 'absolute',
				top: `${(locationData?.top ?? 0) - (isForShotEditorModal ? 0 : 70)}px`,
				left: `${locationData?.left}px`,
				bottom: `${locationData?.bottom}px`,
				right: `${locationData?.right}px`,
				width: `${locationData?.width}px`,
				height: `${locationData?.height}px`,
				pointerEvents: 'none',
			}}
		>
			<div className={classNames('video-hover-options-buttons', isHovering && 'hover')}>
				{(roomState === ROOM_STATES.EDITING || isForShotEditorModal) && (
					<div
						className="video-hover-options-button"
						onClick={() => toggleExpandedCallback(sipStreamId)}
					>
						<Icon
							name={ expanded ? ICONS.FIT : ICONS.PREVIEW}
							color={COLORS.WHITE}
							size={12}
						/>
					</div>
				)}
			</div>
		</div>
	);
}
